import MonthlyReportDialog from "./MonthlyReportDialog.vue";
export default MonthlyReportDialog;
